import { render, staticRenderFns } from "./AIAutoImproveWritingButton.vue?vue&type=template&id=5d054fdc&scoped=true&"
import script from "./AIAutoImproveWritingButton.vue?vue&type=script&lang=js&"
export * from "./AIAutoImproveWritingButton.vue?vue&type=script&lang=js&"
import style0 from "./AIAutoImproveWritingButton.vue?vue&type=style&index=0&id=5d054fdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d054fdc",
  null
  
)

export default component.exports